import { BrowserRouter as Router, Routes, Route, useParams, useLocation } from 'react-router-dom';
import { BrandProvider } from './components/BrandProvider';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Invoices from './pages/invoices/Invoices';
import CreateInvoice from './pages/invoices/create/DocumentForm';
import Invoice from './pages/invoice/Invoice';
import Quotations from './pages/quotations/Quotations';
import CreateQuotation from './pages/quotations/create/DocumentForm';
import Quotation from './pages/quotation/Quotation';
import Receipts from './pages/receipts/Receipts';
import CreateReceipt from './pages/receipts/create/DocumentForm';
import Receipt from './pages/receipt/Receipt';
import Bills from './pages/bills/Bills';
import CreateBill from './pages/bills/create/DocumentForm';
import Bill from './pages/bill/Bill';
import Businesses from './pages/businesses/Businesses';
import CreateBusiness from './pages/businesses/create/CreateBusiness';
import Business from './pages/business/Business';
import Users from './pages/users/Users';
import CreateUser from './pages/users/create/CreateUser';
import User from './pages/user/User';
import Customers from './pages/customers/Customers';
import CreateCustomer from './pages/customers/create/CreateCustomer';
import Customer from './pages/customer/CustomerDetail';
import Companies from './pages/companies/Companies';
import CreateCompany from './pages/companies/create/CreateCompany';
import Company from './pages/company/Company';
import ProductServices from './pages/product-services/ProductServices';
import CreateProductService from './pages/product-services/create/CreateProductService';
import ProductService from './pages/product-service/ProductService';
import Campaigns from './pages/campaigns/Campaigns';
import CreateCampaign from './pages/campaigns/CreateCampaignForm';
import Campaign from './pages/campaign/Campaign';
import Signatures from './pages/signatures/Signatures';
import SignatureDetail from './pages/signatures/SignatureDetail';
import EditSignature from './pages/signatures/EditSignature';
import Deals from './pages/deals/Deals';
import CreateDeal from './pages/deals/CreateDealForm';
import Deal from './pages/deal/Deal';
import Reminders from './pages/reminders/Reminders';
import CreateReminder from './pages/reminders/CreateReminderForm';
import Reminder from './pages/reminder/Reminder';
import Workflows from './pages/workflows/Workflows';
import CreateWorkflow from './pages/workflows/CreateWorkflowForm';
import Workflow from './pages/workflow/Workflow';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Logout from './pages/Logout';
import { Toaster } from "@/components/ui/toaster"
import ErrorBoundary from '@/components/shared/ErrorBoundary';
import CrmActivities from './pages/crm/Activities';
import NewActivity from './pages/crm/NewActivity';
import Calendar from './pages/calendar/Calendar';
import Suppliers from './pages/suppliers/Suppliers';
import CreateSupplier from './pages/suppliers/create/CreateSupplier';
import SupplierDetail from './pages/supplier/SupplierDetail';
import EditSupplier from './pages/supplier/EditSupplier';
// Chart of Accounts and Transactions imports
import ChartOfAccounts from './pages/chart-of-accounts';
import ChartOfAccountDetail from './pages/chart-of-accounts/ChartOfAccountDetail';
import CreateChartOfAccount from './pages/chart-of-accounts/create';
import Transactions from './pages/transactions';
import TransactionDetail from './pages/transactions/TransactionDetail';
import CreateTransaction from './pages/transactions/create';
import AllChartOfAccounts from './pages/chart-of-accounts/all';
// Bank Accounts imports
import BankAccounts from './pages/business/bank-accounts/BankAccounts';
// Reports imports
import Reports from './pages/reports/Reports';
import CreateReport from './pages/reports/create/CreateReport';
import Report from './pages/report/Report';
import { useEffect } from 'react';
import { DevTools } from '@/components/DevTools';
// Document Processing imports
import DocumentTypes from './pages/document-types/DocumentTypes';
import DocumentTemplates from './pages/document-templates/DocumentTemplates';
import DocumentUploads from './pages/document-uploads/DocumentUploads';
import ExceptionQueue from './pages/exception-queue/ExceptionQueue';
import ApprovalWorkflows from './pages/approval-workflows/ApprovalWorkflows';
import AIConfiguration from './pages/ai-configuration/AIConfiguration';
import ApprovalRequests from './pages/approval-requests/ApprovalRequests';
import ProcessingQueue from './pages/processing-queue/ProcessingQueue';
import DocumentProcessingSettings from "./pages/document-processing-settings/DocumentProcessingSettings";
import DocumentProcessingReports from "./pages/document-processing-reports/DocumentProcessingReports";
// Inventory Management imports
import InventoryItems from './pages/inventory/items/InventoryItems';
import InventoryCategories from './pages/inventory/categories/InventoryCategories';
import StockMovements from './pages/inventory/movements/StockMovements';
import InventoryReports from './pages/inventory/reports/InventoryReports';
// Manufacturing imports
import Recipes from './pages/manufacturing/recipes/Recipes';
import ProductionJobs from './pages/manufacturing/production-jobs/ProductionJobs';
import WorkOrders from './pages/manufacturing/work-orders/WorkOrders';
import CreateWorkOrder from './pages/manufacturing/work-orders/CreateWorkOrder';
import EditWorkOrder from './pages/manufacturing/work-orders/EditWorkOrder';
import WorkOrderDetail from './pages/manufacturing/work-orders/WorkOrderDetail';
import ProductionSchedule from './pages/manufacturing/schedule/ProductionSchedule';
import CreateSchedule from './pages/manufacturing/schedule/CreateSchedule';
import EditSchedule from './pages/manufacturing/schedule/EditSchedule';
import ScheduleCalendar from './pages/manufacturing/schedule/ScheduleCalendar';
import QualityControl from './pages/manufacturing/quality-control/QualityControl';
import CreateQualityCheck from './pages/manufacturing/quality-control/CreateQualityCheck';
import EditQualityCheck from './pages/manufacturing/quality-control/EditQualityCheck';
import QualityCheckDetail from './pages/manufacturing/quality-control/QualityCheckDetail';
import ProductionReports from './pages/manufacturing/reports/ProductionReports';
import CreateProductionReport from './pages/manufacturing/reports/CreateProductionReport';
import ProductionReportDetail from './pages/manufacturing/reports/ProductionReportDetail';
// Procurement imports
import PurchaseOrders from './pages/procurement/purchase-orders/PurchaseOrders';
import CreatePurchaseOrder from './pages/procurement/purchase-orders/CreatePurchaseOrder';
import EditPurchaseOrder from './pages/procurement/purchase-orders/EditPurchaseOrder';
import PurchaseOrderDetail from './pages/procurement/purchase-orders/PurchaseOrderDetail';
import PurchaseRequisitions from './pages/procurement/requisitions/PurchaseRequisitions';
import CreatePurchaseRequisition from './pages/procurement/requisitions/CreatePurchaseRequisition';
import EditPurchaseRequisition from './pages/procurement/requisitions/EditPurchaseRequisition';
import PurchaseRequisitionDetail from './pages/procurement/requisitions/PurchaseRequisitionDetail';
import GoodsReceived from './pages/procurement/goods-received/GoodsReceived';
import CreateGoodsReceived from './pages/procurement/goods-received/CreateGoodsReceived';
import EditGoodsReceived from './pages/procurement/goods-received/EditGoodsReceived';
import GoodsReceivedDetail from './pages/procurement/goods-received/GoodsReceivedDetail';
import SupplierMall from './pages/procurement/supplier-mall/SupplierMall';
import SupplierMallItemDetail from './pages/procurement/supplier-mall/SupplierMallItemDetail';
import SupplierQuotations from './pages/procurement/quotations/SupplierQuotations';
import CreateQuotationRequest from './pages/procurement/quotations/CreateQuotationRequest';
import QuotationDetail from './pages/procurement/quotations/QuotationDetail';
import CompareQuotations from './pages/procurement/quotations/CompareQuotations';
import ProcurementDashboard from './pages/procurement/ProcurementDashboard';
// Manufacturing imports
import CreateRecipe from './pages/manufacturing/recipes/CreateRecipe';
import EditRecipe from './pages/manufacturing/recipes/EditRecipe';
import RecipeDetail from './pages/manufacturing/recipes/RecipeDetail';
import CreateProductionJob from './pages/manufacturing/production-jobs/CreateProductionJob';
import EditProductionJob from './pages/manufacturing/production-jobs/EditProductionJob';
import ProductionJobDetail from './pages/manufacturing/production-jobs/ProductionJobDetail';
// Warehouse imports
import Warehouses from './pages/warehouse/Warehouses';
import CreateWarehouse from './pages/warehouse/CreateWarehouse';
import EditWarehouse from './pages/warehouse/EditWarehouse';
import WarehouseDetail from './pages/warehouse/WarehouseDetail';
import WarehouseLocations from './pages/warehouse/locations/WarehouseLocations';
import CreateWarehouseLocation from './pages/warehouse/locations/CreateWarehouseLocation';
import EditWarehouseLocation from './pages/warehouse/locations/EditWarehouseLocation';
import WarehouseLocationDetail from './pages/warehouse/locations/WarehouseLocationDetail';
import StockTransfers from './pages/warehouse/transfers/StockTransfers';
import CreateStockTransfer from './pages/warehouse/transfers/CreateStockTransfer';

function BusinessWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <Business publicId={publicId} />;
}

function UserWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <User publicId={publicId} />;
}

function CustomerWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <Customer publicId={publicId} />;
}

function CompanyWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <Company publicId={publicId} />;
}

function ProductServiceWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <ProductService publicId={publicId} />;
}

function CampaignWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <Campaign publicId={publicId} />;
}

function DealWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <Deal publicId={publicId} />;
}

function ReminderWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <Reminder publicId={publicId} />;
}

function WorkflowWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <Workflow publicId={publicId} />;
}

function InvoiceWrapper() {
  const { id } = useParams<{ id: any }>();
  return <Invoice invoiceId={id} />;
}

function QuotationWrapper() {
  const { id } = useParams<{ id: any }>();
  return <Quotation quotationId={id} />;
}

function ReceiptWrapper() {
  const { id } = useParams<{ id: any }>();
  return <Receipt receiptId={id} />;
}

function BillWrapper() {
  const { id } = useParams<{ id: any }>();
  return <Bill billId={id} />;
}

function SupplierWrapper() {
  const { publicId } = useParams<{ publicId: any }>();
  return <SupplierDetail publicId={publicId} />;
}

function ChartOfAccountWrapper() {
  const { id: publicId } = useParams<{ id: string }>();
  return <ChartOfAccountDetail id={publicId} />;
}

function TransactionWrapper() {
  const { id } = useParams<{ id: string }>();
  return <TransactionDetail id={id} />;
}

function ReportDetailWrapper() {
  const { publicId } = useParams<{ publicId: string }>();
  return <Report publicId={publicId || ''} />;
}

function BankAccountsWrapper() {
  const { publicId } = useParams<{ publicId: string }>();
  return <BankAccounts publicId={publicId} />;
}

// Separate component for routes that can use router hooks
function AppRoutes() {
  const location = useLocation();

  // Initialize module permissions from localStorage
  useEffect(() => {
    const modulePermissions = localStorage.getItem('modulePermissions');
    if (!modulePermissions) {
      // Convert legacy format to new module permissions format if exists
      const accessToken = localStorage.getItem('accessToken');
      if (accessToken) {
        try {
          // Check if any module permissions list already exists
          const existingPermissions = JSON.parse(localStorage.getItem('permissions') || '[]');
          if (existingPermissions.length > 0) {
            // Format them to the new structure
            const formattedPermissions: Record<string, any[]> = {};
            
            // Default to the first business ID in the list, or 1 if none exists
            const businesses = JSON.parse(localStorage.getItem('businesses') || '[]');
            const businessIds = businesses.map((b: any) => b.id);
            
            // For each business ID, add the permissions
            businessIds.forEach((id: number) => {
              formattedPermissions[id] = existingPermissions;
            });
            
            // Save to localStorage
            localStorage.setItem('modulePermissions', JSON.stringify(formattedPermissions));
          }
        } catch (error) {
          console.error('Error initializing module permissions:', error);
          // If there's an error, redirect to logout
          window.location.href = '/logout';
        }
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Routes key={location.pathname}>
        {/* Dashboard Route */}
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <main className="flex-1 pb-16 lg:pb-0">
                <div className="mobile-container py-6">
                  <Dashboard />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Invoice Routes */}
        <Route
          path="/invoices"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Invoices />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/invoices/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateInvoice />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/invoice/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <InvoiceWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Bill Routes */}
        <Route
          path="/bills"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Bills />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/bill/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <BillWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/bills/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateBill />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Quotation Routes */}
        <Route
          path="/quotations"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Quotations />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/quotations/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateQuotation />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/quotation/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <QuotationWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Receipt Routes */}
        <Route
          path="/receipts"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Receipts />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/receipts/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateReceipt />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/receipt/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ReceiptWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Business Routes */}
        <Route
          path="/businesses"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Businesses />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/businesses/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateBusiness />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/business/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <BusinessWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Bank Accounts Routes */}
        <Route
          path="/business/bank-accounts/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <BankAccountsWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* User Routes */}
        <Route
          path="/users"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Users />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/users/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateUser />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/user/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <UserWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Customer Routes */}
        <Route
          path="/customers"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Customers />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/customers/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateCustomer />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/customer/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CustomerWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Company Routes */}
        <Route
          path="/companies"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Companies />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/companies/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateCompany />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/company/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CompanyWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Supplier Routes */}
        <Route
          path="/suppliers"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Suppliers />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/suppliers/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateSupplier />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/supplier/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <SupplierWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/supplier/edit/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditSupplier />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Product Service Routes */}
        <Route
          path="/product-service/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ProductServiceWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/product-services/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateProductService />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/product-services"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ProductServices />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Campaign Routes */}
        <Route
          path="/campaigns"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Campaigns />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/campaigns/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateCampaign 
                    businessId={1} 
                    onSuccess={() => window.history.back()}
                  />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/campaign/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CampaignWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Deal Routes */}
        <Route
          path="/deals"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Deals />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/deals/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateDeal 
                    businessId={1}
                    pipelineStages={[]}
                    onSuccess={() => window.history.back()}
                  />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/deal/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <DealWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Reminder Routes */}
        <Route
          path="/reminders"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Reminders />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/reminders/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateReminder 
                    businessId={1}
                    onSuccess={() => window.history.back()}
                  />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/reminder/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ReminderWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Workflow Routes */}
        <Route
          path="/workflows"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Workflows />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/workflows/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateWorkflow 
                    businessId={1}
                    onSuccess={() => window.history.back()}
                  />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/workflow/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <WorkflowWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Profile & Settings Routes */}
        <Route
          path="/profile"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Profile />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/settings"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Settings />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        
        {/* Auth Routes */}
        <Route
          path="/login"
          element={
            <main className="flex-1">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Login />
              </div>
              <Toaster />
            </main>
          }
        />
        <Route
          path="/signup"
          element={
            <main className="flex-1">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Signup />
              </div>
              <Toaster />
            </main>
          }
        />
        <Route
          path="/logout"
          element={
            <main className="flex-1">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Logout />
              </div>
              <Toaster />
            </main>
          }
        />

        {/* CRM Activity Routes */}
        <Route
          path="/crm/activities"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CrmActivities />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/crm/activities/new"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <NewActivity />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/crm/activities/new/:customerId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <NewActivity />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Customer Detail Route with new implementation */}
        <Route
          path="/customer-detail/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CustomerWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Calendar Route */}
        <Route
          path="/calendar"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Calendar />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Signature Routes */}
        <Route
          path="/signatures"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Signatures />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/signatures/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <SignatureDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/signatures/edit/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditSignature />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Chart of Accounts Routes */}
        <Route
          path="/chart-of-accounts"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ChartOfAccounts />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/chart-of-accounts/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateChartOfAccount />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/chart-of-accounts/all"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <AllChartOfAccounts />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/chart-of-accounts/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ChartOfAccountWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Transaction Routes */}
        <Route
          path="/transactions"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Transactions />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/transactions/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateTransaction />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/transactions/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <TransactionWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Reports Routes */}
        <Route
          path="/reports"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Reports />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/reports/create/:reportType"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateReport />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/report/:publicId"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ReportDetailWrapper />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Document Processing Routes */}
        <Route
          path="/document-types"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <DocumentTypes />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/document-templates"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <DocumentTemplates />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/document-uploads"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <DocumentUploads />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/exception-queue"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ExceptionQueue />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/approval-workflows"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ApprovalWorkflows />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/ai-configuration"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <AIConfiguration />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/approval-requests"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ApprovalRequests />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/processing-queue"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ProcessingQueue />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Document Processing Settings Routes */}
        <Route
          path="/document-processing-settings"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <DocumentProcessingSettings />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Document Processing Reports Routes */}
        <Route
          path="/document-processing-reports"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <DocumentProcessingReports />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Inventory Management Routes */}
        <Route
          path="/inventory/items"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <InventoryItems />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/inventory/categories"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <InventoryCategories />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/inventory/movements"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <StockMovements />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/inventory/reports"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <InventoryReports />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Manufacturing Routes */}
        <Route
          path="/manufacturing/recipes"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Recipes />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/production-jobs"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ProductionJobs />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/work-orders"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <WorkOrders />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/work-orders/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateWorkOrder />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/work-orders/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <WorkOrderDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/work-orders/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditWorkOrder />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/schedule"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ProductionSchedule />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/schedule/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateSchedule />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/schedule/calendar"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ScheduleCalendar />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/schedule/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditSchedule />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/quality-control"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <QualityControl />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/quality-control/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateQualityCheck />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/quality-control/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <QualityCheckDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/quality-control/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditQualityCheck />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/reports"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ProductionReports />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/reports/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateProductionReport />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/reports/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ProductionReportDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Procurement Routes */}
        <Route
          path="/procurement/purchase-orders"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <PurchaseOrders />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/purchase-orders/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreatePurchaseOrder />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/purchase-orders/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <PurchaseOrderDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/purchase-orders/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditPurchaseOrder />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/requisitions"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <PurchaseRequisitions />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/requisitions/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreatePurchaseRequisition />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/requisitions/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <PurchaseRequisitionDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/requisitions/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditPurchaseRequisition />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/goods-received-vouchers"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <GoodsReceived />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/goods-received"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <GoodsReceived />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/goods-received/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateGoodsReceived />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/goods-received/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <GoodsReceivedDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/goods-received/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditGoodsReceived />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/supplier-mall"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <SupplierMall />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/supplier-mall/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <SupplierMallItemDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/quotations"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <SupplierQuotations />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/quotations/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateQuotationRequest />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/quotations/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <QuotationDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/quotations/compare"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CompareQuotations />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/procurement/dashboard"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ProcurementDashboard />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Manufacturing Management Routes */}
        <Route
          path="/manufacturing/recipes/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateRecipe />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/recipes/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditRecipe />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/recipes/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <RecipeDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/production-jobs/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateProductionJob />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/production-jobs/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditProductionJob />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/manufacturing/production-jobs/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <ProductionJobDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />

        {/* Warehouse Management Routes */}
        <Route
          path="/warehouses"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <Warehouses />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/warehouses/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateWarehouse />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/warehouses/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditWarehouse />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/warehouses/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <WarehouseDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/warehouse/locations"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <WarehouseLocations />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/warehouse/locations/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateWarehouseLocation />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/warehouse/locations/:id"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <WarehouseLocationDetail />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/warehouse/locations/:id/edit"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <EditWarehouseLocation />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/warehouse/transfers"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <StockTransfers />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
        <Route
          path="/warehouse/transfers/create"
          element={
            <>
              <Navbar />
              <main className="flex-1">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                  <CreateStockTransfer />
                </div>
                <Toaster />
              </main>
              <Footer />
            </>
          }
        />
      </Routes>
      
      <DevTools />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrandProvider>
        <Router>
          <AppRoutes />
        </Router>
      </BrandProvider>
    </ErrorBoundary>
  );
}

export default App; 